const DOMAIN_ERROR_PREFIX = 'logo_maker_error::';

module.exports = {
    DOMAIN_ERROR_PREFIX
};
